<template>
  <div>
    <cangchu-sy />
  </div>
</template>

<script>
// 获取接口地址
import CangchuSy from '../components/ccManage/ccsy/cangchuSy.vue'

export default {
  name: 'Ccsy',
  components: {
    // sideMenu,
    // Header,
    CangchuSy
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
